import {
  LOAD_BEST_TEACHING_AWARD_PARAMS,
  UPDATE_BEST_TEACHING_AWARD_PARAMS
} from '../constants/action-types'

const defaultState = {
  setupIndex: 0,
  campus: 'SGP',
  courseType: 'elective'
}

export default (state = defaultState, action) => {
  switch (action.type) {
    case LOAD_BEST_TEACHING_AWARD_PARAMS: {
      return {
        setupIndex: setupIndex,
        campus: campus,
        courseType: courseType
      }
    }

    case UPDATE_BEST_TEACHING_AWARD_PARAMS: {
      return {
        ...state,
        setupIndex: action.payload.setupIndex,
        campus: action.payload.campus,
        courseType: action.payload.courseType
      }
    }
    default:
      return state
  }
}
